import { styled, Box, Typography, Stack } from "@mui/material";
import { SIGNUP_COLORS } from "../../../../public/SignUp/tokens";
import { FiEye, FiEyeOff } from "react-icons/fi";

export const PasswordValidateContainer = styled(Box)(() => ({
  width: "416px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
}));

export const StyledImage = styled("img")(() => ({
  width: "16px",
  height: "16px",
  display: "block",
  cursor: "pointer",
}));

export const ValidationText = styled(Typography)(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: SIGNUP_COLORS.textPrimary,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  margin: 0,
  padding: 0,
  "&:not(:last-child)": {
    marginBottom: "4px",
  },
}));

export const ValidationTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  alignSelf: "stretch",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: SIGNUP_COLORS.textPrimary,
  marginBottom: "8px",
}));

export const Icon = styled("svg")(() => ({
  verticalAlign: "middle",
  marginRight: "4px",
}));

export const MainGrid = styled(Stack)(() => ({
  width: "100%",
  height: "100%",
}));

export const BoxContainer = styled(Box)(() => ({
  width: "100%",
  maxWidth: "520px",
  alignSelf: "flex-start",
}));

export const Title = styled("h2")(() => ({
  width: "100%",
  color: "#1D2939",
  fontFamily: "Manrope",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px",
  marginBottom: "0px",
  marginTop: "0px",
  gap: "4px",
}));

export const FirstTextBox = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  alignSelf: "stretch",
}));

export const Text = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: SIGNUP_COLORS.textSecondary,
}));

export const StrengthBarContainer = styled(Box)(() => ({
  maxWidth: "415px",
  position: "relative",
  display: "flex",
  padding: "0px 4px",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: "8px",
  alignSelf: "stretch",
  margin: 0,
}));

export const PasswordStrengthText = styled(Typography)(() => ({
  position: "absolute",
  bottom: "-8px",
  right: "5px",
  textAlign: "right",
  width: "100%",
  fontSize: "12px",
  fontStyle: "normal",
  lineHeight: "16px",
  fontFamily: "Manrope",
  fontWeight: 700,
  letterSpacing: "0.4px",
}));

export const ProgressBarContainer = styled(Box)(() => ({
  bottom: "20px",
  height: "4px",
  width: "100%",
  backgroundColor: "#FFFFFF",
  position: "relative",
  borderRadius: "4px",
  overflow: "hidden",
  gap: "8px",
}));

export const ProgressSegment = styled(Box)<{ width: string; color: string; left: string }>(
  ({ width, color, left }) => ({
    position: "absolute",
    height: "4px",
    width,
    backgroundColor: color,
    left,
    zIndex: 1,
  })
);

export const EyeOffIcon = styled(FiEyeOff)(() => ({
  cursor: "pointer",
}));

export const EyeOpenIcon = styled(FiEye)(() => ({
  cursor: "pointer",
}));
